module.exports = {"420902001":"书院街道","420902002":"新华街道","420902003":"广场街道","420902004":"车站街道","420902100":"新铺镇","420902101":"西河镇","420902102":"杨店镇","420902103":"陡岗镇","420902104":"肖港镇","420902105":"毛陈镇","420902106":"三汊镇","420902107":"祝站镇","420902200":"朋兴乡","420902201":"卧龙乡","420902202":"闵集乡","420902400":"经济开发区","420902450":"朱湖","420902500":"东山头","420902570":"孝感开发区丹阳","420902571":"孝感开发区孝天","420902572":"孝感开发区槐荫"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420902.json
// module id = 1879
// module chunks = 0